import { render, staticRenderFns } from "./DynamicModal.vue?vue&type=template&id=704681ec"
import script from "./DynamicModal.vue?vue&type=script&lang=js"
export * from "./DynamicModal.vue?vue&type=script&lang=js"
import style0 from "./DynamicModal.vue?vue&type=style&index=0&id=704681ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports